import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["component", "clsPrefix", "className", "disabled", "style", "multiple", "accept", "children", "name", "action", "headers", "data", "type", "listType", "fileList", "defaultFileList", "size", "beforeUpload", "showUploadList", "supportServerRender", "onStart", "onSuccess", "multipart", "onReady", "customRequest", "withCredentials", "onChange"];
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-upload.
* homepage: https://github.com/react-component/upload
*/
import React, { Component } from 'react';
import classNames from 'classnames';
import defaultRequest from './request';
import getUid from './uid';
import PropTypes from 'prop-types';
var propTypes = {
  component: PropTypes.string,
  style: PropTypes.object,
  clsPrefix: PropTypes.string,
  className: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  accept: PropTypes.string,
  children: PropTypes.any,
  onStart: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  headers: PropTypes.object,
  beforeUpload: PropTypes.func,
  customRequest: PropTypes.func,
  withCredentials: PropTypes.bool
};

var AjaxUploader = /*#__PURE__*/function (_Component) {
  _inherits(AjaxUploader, _Component);

  var _super = _createSuper(AjaxUploader);

  function AjaxUploader(props) {
    var _this;

    _classCallCheck(this, AjaxUploader);

    _this = _super.call(this, props);
    _this.reqs = {};
    _this.state = {
      uid: getUid()
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onFileDrop = _this.onFileDrop.bind(_assertThisInitialized(_this));
    _this.uploadFiles = _this.uploadFiles.bind(_assertThisInitialized(_this));
    _this.upload = _this.upload.bind(_assertThisInitialized(_this));
    _this.post = _this.post.bind(_assertThisInitialized(_this));
    _this.reset = _this.reset.bind(_assertThisInitialized(_this));
    _this.abort = _this.abort.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AjaxUploader, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.abort();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var files = e.target.files;
      this.uploadFiles(files);
      this.reset();
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var el = this.file;

      if (!el) {
        return;
      }

      el.click();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (e.key === 'Enter') {
        this.onClick();
      }
    }
  }, {
    key: "onFileDrop",
    value: function onFileDrop(e) {
      if (e.type === 'dragover') {
        e.preventDefault();
        return;
      }

      var files = e.dataTransfer.files;
      this.uploadFiles(files);
      e.preventDefault();
    }
  }, {
    key: "uploadFiles",
    value: function uploadFiles(files) {
      var postFiles = Array.prototype.slice.call(files);
      var len = postFiles.length;
      var mergeFiles = this.props.mergeFiles;

      if (mergeFiles) {
        var file = {
          filesArray: postFiles,
          uid: getUid()
        };
        this.upload(file, postFiles);
      } else {
        for (var i = 0; i < len; i++) {
          var _file = postFiles[i];
          _file.uid = getUid();
          this.upload(_file, postFiles);
        }
      }
    }
  }, {
    key: "upload",
    value: function upload(file, fileList) {
      var _this2 = this;

      var props = this.props;

      if (!props.beforeUpload) {
        // always async in case use react state to keep fileList
        return setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }

      var before = props.beforeUpload(file, fileList);

      if (before && before.then) {
        before.then(function (processedFile) {
          var processedFileType = Object.prototype.toString.call(processedFile);

          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
            _this2.post(processedFile);
          } else {
            _this2.post(file);
          }
        });
      } else if (before !== false) {
        setTimeout(function () {
          return _this2.post(file);
        }, 0);
      }
    }
  }, {
    key: "post",
    value: function post(file) {
      var _this3 = this;

      if (!this.mounted) {
        return;
      }

      var props = this.props;
      var data = props.data;
      var onStart = props.onStart;

      if (typeof data === 'function') {
        data = data(file);
      }

      var uid = file.uid;
      var request = props.customRequest || defaultRequest;
      this.reqs[uid] = request({
        action: props.action,
        filename: props.name,
        file: file.filesArray || file,
        data: data,
        headers: props.headers,
        withCredentials: props.withCredentials,
        onProgress: function onProgress(e) {
          props.onProgress(e, file);
        },
        onSuccess: function onSuccess(ret) {
          delete _this3.reqs[uid];
          props.onSuccess(ret, file);
        },
        onError: function onError(err, ret) {
          delete _this3.reqs[uid];
          props.onError(err, ret, file);
        }
      });
      onStart(file);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        uid: getUid()
      });
    }
  }, {
    key: "abort",
    value: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;

        if (file && file.uid) {
          uid = file.uid;
        }

        if (reqs[uid] && reqs[uid].abort) {
          reqs[uid].abort();
        }

        delete reqs[uid];
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid] && reqs[uid].abort) {
            reqs[uid].abort();
          }

          delete reqs[uid];
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this4 = this;

      var _this$props = this.props,
          Tag = _this$props.component,
          clsPrefix = _this$props.clsPrefix,
          className = _this$props.className,
          disabled = _this$props.disabled,
          style = _this$props.style,
          multiple = _this$props.multiple,
          accept = _this$props.accept,
          children = _this$props.children,
          name = _this$props.name,
          action = _this$props.action,
          headers = _this$props.headers,
          data = _this$props.data,
          type = _this$props.type,
          listType = _this$props.listType,
          fileList = _this$props.fileList,
          defaultFileList = _this$props.defaultFileList,
          size = _this$props.size,
          beforeUpload = _this$props.beforeUpload,
          showUploadList = _this$props.showUploadList,
          supportServerRender = _this$props.supportServerRender,
          onStart = _this$props.onStart,
          onSuccess = _this$props.onSuccess,
          multipart = _this$props.multipart,
          onReady = _this$props.onReady,
          customRequest = _this$props.customRequest,
          withCredentials = _this$props.withCredentials,
          onChange = _this$props.onChange,
          others = _objectWithoutProperties(_this$props, _excluded);

      var cls = classNames((_classNames = {}, _defineProperty(_classNames, clsPrefix, true), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _defineProperty(_classNames, className, className), _classNames));
      var events = disabled ? {} : {
        onClick: this.onClick,
        onKeyDown: this.onKeyDown,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: '0'
      };
      return /*#__PURE__*/React.createElement(Tag, _extends({}, events, {
        className: cls,
        role: "button",
        style: style
      }, others), /*#__PURE__*/React.createElement("input", {
        type: "file" // ref="file"
        ,
        ref: function ref(el) {
          return _this4.file = el;
        },
        key: this.state.uid,
        style: {
          display: 'none'
        },
        accept: accept,
        multiple: multiple,
        onChange: this.onChange
      }), children);
    }
  }]);

  return AjaxUploader;
}(Component);

;
AjaxUploader.propTypes = propTypes;
export default AjaxUploader;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-upload/src/AjaxUploader.js